import { usePost, UsePostParams } from '../../../../api';
import { useCallback } from 'react';
import { USER_MANAGEMENT_BASE_URL } from '../consts';
import { User } from '../../types/User';

interface ChangeMatchingPrimaryUserPayload {
    newPrimaryUserGuid: User['guid'];
    oldPrimaryUserGuid: User['guid'];
}

type ChangeMatchingPrimaryUserResponse = ChangeMatchingPrimaryUserPayload;

interface ChangeMatchingPrimaryUserErrorResponse {
    error: string;
}

type ChangeMatchingPrimaryUserParams = UsePostParams<
    ChangeMatchingPrimaryUserPayload,
    ChangeMatchingPrimaryUserResponse,
    ChangeMatchingPrimaryUserErrorResponse
>;

export const useChangeMatchingPrimaryUser = (params: ChangeMatchingPrimaryUserParams) => {
    const { post, ...rest } = usePost(params);

    const changeMatchingPrimaryUser = useCallback(
        (newPrimaryUserGuid: User['guid'], oldPrimaryUserGuid: User['guid']) =>
            post(`${USER_MANAGEMENT_BASE_URL}/matchUsers/changePrimary`, {
                newPrimaryUserGuid,
                oldPrimaryUserGuid
            }),
        [post]
    );

    return {
        ...rest,
        changeMatchingPrimaryUser
    };
};
